import React, { useEffect, useState } from "react";
import "./LazyLoadPlaceholder.css";

function LazyLoadPlaceholder() {
  return <div className="image-lazy-load-placeholder-skeletion"></div>;
}

export default LazyLoadPlaceholder;
